import './PilotHeader.scss'
import { useEffect, useState } from 'react';
import { useSdoAdminEligibilityCriteriaProvider } from '../../providers/SdoAdminEligibilityCriteriaProvider';

export default function PilotHeader() {

    const sdoAdminEligibilityCriteriaContext = useSdoAdminEligibilityCriteriaProvider();
    const [pilotHeaderDetails, setPilotHeaderDetails] = useState([] as any);

    useEffect(() => {
        if(!Object.keys(sdoAdminEligibilityCriteriaContext.pilotRequestsData).length) return;

        const headerDetails = [
            {label: 'Pilot Name:', value: sdoAdminEligibilityCriteriaContext.pilotRequestsData.pilotName},
            {label: 'Seniority:', value: sdoAdminEligibilityCriteriaContext.pilotRequestsData.seniority},
            {label: 'Base:', value: sdoAdminEligibilityCriteriaContext.pilotRequestsData.base},
            {label: 'Equipment:', value: sdoAdminEligibilityCriteriaContext.pilotRequestsData.equipment},
            {label: 'Rank:', value: sdoAdminEligibilityCriteriaContext.pilotRequestsData.rank},
        ]
        if(sdoAdminEligibilityCriteriaContext.pilotRequestsData.additionalQualification) {
            headerDetails.push({label: 'Additional Qualification:', value: sdoAdminEligibilityCriteriaContext.pilotRequestsData.additionalQualification})
        }
        setPilotHeaderDetails(headerDetails);

    }, [sdoAdminEligibilityCriteriaContext.pilotRequestsData])

    return (
        <div className='c-pilot-header'>
            {pilotHeaderDetails.map((detail, i) => {
                return (
                    <div key={i} className={sdoAdminEligibilityCriteriaContext.pilotRequestsData.additionalQualification ? 'c-pilot-detail c-pilot-detail--add-qual' : 'c-pilot-detail'}>
                        <p className='pilot__detail__lbl'>{detail.label}</p>
                        <p className='pilot__detail__value'>{detail.value}</p>
                    </div> 
                )
            })}
        </div>
    )
}
